import { Box, Button, Header, Loader, Table, Text } from '@profitowi/component-library';
import { AxiosError } from 'axios';
import useAgentId from 'pages/Agent/useAgentId';
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { SortingRule } from 'react-table';

import ErrorMessages from 'components/ErrorMessages/ErrorMessages';
import { AGENT } from 'constants/queries/agent';
import { usePagination } from 'hooks/usePagination';
import { getAgentBlockades } from 'services/agent';
import { AgentDetailsBlockade } from 'types/agent';
import { Page } from 'types/request';
import { decodeUriSortParams } from 'utils/table';

import { createColumns } from './columns';
import AddAgentBlockadeModal from './components/AddAgentBlockadeModal/AddAgentBlockadeModal';
import DisableBlockadeModal from './components/DisableBlockadeModal/DisableBlockadeModal';

const Blockades = () => {
  const agentId = useAgentId();
  const pagination = usePagination(10);
  const { currentPage, perPage } = pagination;
  const [isAddModalVisible, setIsAddModalVisible] = useState<boolean>(false);
  const [isDeleteBlockadeModalVisible, setIsDeleteBlockadeModalVisible] = useState<boolean>(false);
  const [blockadeToDelete, setBlockadeToDelete] = useState<AgentDetailsBlockade | null>(null);
  const [sortBy, setSortBy] = useState<Array<SortingRule<any>>>([
    {
      id: 'createdAt',
      desc: true,
    },
  ]);
  const handleSortBy = useCallback((sortBy: SortingRule<any>[]) => setSortBy(sortBy), []);

  const { data, isLoading, isError, isSuccess, error, refetch, isFetching } = useQuery<
    Page<AgentDetailsBlockade>,
    AxiosError
  >([AGENT.AGENT_BLOCKADES, agentId, currentPage, perPage, sortBy], () =>
    getAgentBlockades(agentId, currentPage, perPage, decodeUriSortParams(sortBy))
  );

  return (
    <Box>
      <div className="flex justify-between my-4">
        <Header as="h4" size="lg" weight="semibold">
          Blokady
        </Header>
        <Button
          variant="outline-primary"
          className="px-4 py-1"
          onPress={() => setIsAddModalVisible(true)}>
          <Text weight="semibold">
            Dodaj
            <i className="bi bi-plus-lg ml-2" />
          </Text>
        </Button>
      </div>

      {isError && <ErrorMessages error={error} />}

      {isLoading && <Loader className="h-12 w-12" />}
      {isSuccess && data && (
        <Box.FullWidth>
          <Table
            data={data.content ?? []}
            columns={createColumns(setBlockadeToDelete, () =>
              setIsDeleteBlockadeModalVisible(true)
            )}
            pagination={pagination}
            totalPages={data.totalPages}
            sortBy={sortBy}
            onSortBy={handleSortBy}
            isLoading={isFetching}
          />
        </Box.FullWidth>
      )}
      <AddAgentBlockadeModal
        closeModal={() => setIsAddModalVisible(false)}
        visible={isAddModalVisible}
        refetch={refetch}
      />
      <DisableBlockadeModal
        blockadeToDelete={blockadeToDelete}
        setBlockadeToDelete={setBlockadeToDelete}
        closeModal={() => setIsDeleteBlockadeModalVisible(false)}
        visible={isDeleteBlockadeModalVisible}
        refetch={refetch}
      />
    </Box>
  );
};

export default Blockades;
